import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { collections } from '../../mocks/products';

export default function CollectionsPage() {
  return (
    <div className="min-w-[1024px]">
      <Navbar />
      <main>
        <section className="bg-dark pt-44 pb-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <div className="flex items-center justify-center gap-3 mb-5">
              <span className="w-8 h-px bg-gold" />
              <span className="text-gold text-xs font-semibold uppercase tracking-[0.25em]">What We Offer</span>
              <span className="w-8 h-px bg-gold" />
            </div>
            <h1 className="font-serif text-6xl font-bold text-white mb-5">Our Collections</h1>
            <p className="text-white/50 max-w-xl mx-auto">
              Handpicked furniture for every room — modern furniture near Las Vegas designed for real life and genuine style.
            </p>
          </div>
        </section>

        <section className="py-24 bg-cream-DEFAULT">
          <div className="max-w-7xl mx-auto px-6 space-y-6">
            {collections.map((col, i) => (
              <div
                key={col.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden group ${i % 2 === 1 ? 'direction-rtl' : ''}`}
              >
                {/* Image */}
                <div className={`relative h-80 overflow-hidden ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <img
                    src={col.imageLandscape}
                    alt={`${col.name} furniture collection`}
                    title={`${col.name} Furniture`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>

                {/* Content */}
                <div className={`bg-white p-12 flex flex-col justify-center ${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <span className="text-gold text-xs font-semibold uppercase tracking-[0.2em] mb-3">{col.productCount}+ Pieces</span>
                  <h2 className="font-serif text-4xl font-bold text-dark mb-3">{col.name}</h2>
                  <p className="text-dark/50 text-sm mb-3 italic">{col.tagline}</p>
                  <p className="text-dark/60 text-sm leading-relaxed mb-6">{col.description}</p>
                  <div className="flex flex-wrap gap-2 mb-8">
                    {col.keywords.map((k) => (
                      <span key={k} className="bg-cream-mid text-dark/60 text-xs px-3 py-1 rounded-full border border-cream-dark">{k}</span>
                    ))}
                  </div>
                  <Link to={col.slug} className="inline-flex items-center gap-3 bg-dark text-white px-7 py-3.5 rounded text-xs font-bold uppercase tracking-widest hover:bg-gold transition-colors cursor-pointer whitespace-nowrap self-start">
                    Explore {col.name} <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
